import React from 'react';
import { Container, ContactCircle } from './styles';

interface BiddingContactListProps {
  contactList: Array<string>;
}

const BiddingContactList = ({ contactList }: BiddingContactListProps) => {
  const colors = ['#FFA947', '#53B6B9'];

  const getInitials = (name: string) => {
    const words = name.trim().split(' ');
    if (words.length === 1) return words[0].charAt(0).toUpperCase();
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  return (
    <Container className="mr-2 d-print-none">
      {contactList?.map((contact, index) => (
        <ContactCircle
          key={contact}
          color={colors[index % 2]}
          aria-label={contact}
          data-balloon-pos="up"
          className="position-relative databalloon"
        >
          {getInitials(contact)}
        </ContactCircle>
      ))}
    </Container>
  );
};

export default BiddingContactList;
